<style scoped>
* {
  margin: 0;
  padding: 0;
}

main {
  margin: 0 auto;
  font-family: "Open Sans", sans-serif;
  width: 90%;
  display: flex;
  flex-direction: column;
}
.heading {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 30px;
}

.field_line {
  display: flex;
  flex-direction: row;
  margin: 3px;
}

.title_guide {
  margin-left: 20px;
  color: rgb(0, 0, 0);
}

h6.subtitle{
  background-color: rgba(128, 128, 128, 0.465);
  color: rgb(0, 0, 0);
  width: 100%;
  padding: 5px;
  font-weight: bold;
}
button.print {
  position: absolute;
  right: 2em;
  top: 2em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 105px;
}
.page {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 30px;
}

.field_title {
  font-size: 0.8em;
  margin-left: 5px;
  text-transform: capitalize;
  font-weight: bold;
}

.wallet_number,
.name,
.professional_cnes {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(0, 0, 0);
  width: 60%;
  height: 65px;
  margin: 3px;
}
.plan,
.attendance_procedure {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(0, 0, 0);
  width: 30%;
  height: 65px;
  margin: 3px;
}
.number_sus {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(0, 0, 0);
  width: 40%;
  height: 65px;
  margin: 3px;
}

.name_cnes,
.cpf_number {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(0, 0, 0);
  width: 50%;
  height: 65px;
  margin: 3px;
}

.code_cnes,
.attendance_code,
.attendance_data,
.cid,
.registry_ans,
.wallet_validaty,
.conselho_cnes,
.number_cnes {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(0, 0, 0);
  width: 20%;
  height: 65px;
  margin: 3px;
}
.tl_number,
.uf_cnes {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(0, 0, 0);
  width: 8%;
  height: 65px;
  margin: 3px;
}

.ibge_cnes,
.cbo_cnes {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(0, 0, 0);
  width: 15%;
  height: 65px;
  margin: 3px;
}

.sick_type {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(0, 0, 0);
  width: 25%;
  height: 65px;
  margin: 3px;
}

.field_subtitle {
  margin: 0px 0px 0px 10px;
  font-size: 0.7em;
  text-transform: capitalize;
  font-weight: bold;
}

.attendance_type {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(0, 0, 0);
  width: 45%;
  height: 65px;
  margin: 3px;
}

.field_subtitle_type {
  margin: -10px 0px 5px 0px;
  font-size: 0.7em;
  text-transform: capitalize;
  font-weight: bold;
}

.note {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 200px;
  background-color: rgba(128, 128, 128, 0.465);
  border: 1px solid rgb(0, 0, 0);
  margin: 3px;
}

.assignature {
  display: flex;
  flex-direction: column;
  margin: 3px;
  width: 50%;
  height: 70px;
  background-color: rgba(128, 128, 128, 0.465);
  border: 1px solid rgb(0, 0, 0);
}
.response {
  text-align: justify;
  margin: 5px;
}
.close-button{
  margin-right: 30px;
}
</style>
<template>
<main>
<div class="modal modal-lg active" v-if="localActive" id="modal-id">
  <a class="modal-overlay"></a>
    <div class="modal-container" id="print">
      <div class="page">
        <h2 class="close-button" @click="close()"><i class="icon icon-cross"></i></h2>
          <div class="heading modal-header">
             <button @click="print()" class="print btn btn-default btn-sm"><dr-icon style="width: 20px" name="imprimir" fill="white"></dr-icon>Imprimir</button>
        </div>
        <div class="modal-body">
          <div class="title">
            <h4 class="title_guide">Guia de Consulta</h4>
            <h5 class="number_guide">2- Nº {{this.formData[1].value}}</h5>
          </div>
            <div class="field_line">
              <div class="registry_ans">
                <p class="field_title">1- resgistro ANS</p>
                <div>
                  <p class="response"> {{ this.formData[0].value }} </p>
                </div>
              </div>
              <div class="registry_ans">
                <p class="field_title">3- Data de Emissão da Guia</p>
                <div>
                  <p class="response"> {{ $moment(new Date()).format('DD/MM/YYYY') }} </p>
                </div>
              </div>
            </div>

            <h6 class="subtitle">Dados do Beneficiário</h6>
            <div class="field_line">
              <div class="wallet_number">
                <p class="field_title">4- Número da Carteira</p>
                <div>
                  <p class="response"> {{ this.formData[3].value }} </p>
                </div>
              </div>

              <div class="plan">
                <p class="field_title">5- Plano</p>
                <div>
                  <p class="response"></p>
                </div>
              </div>

              <div class="wallet_validaty">
                <p class="field_title">6- Validade da Carteira</p>
                <div>
                  <p class="response"> {{ $moment(this.formData[4]).format('MM/YYYY') }} </p>
                </div>
              </div>
            </div>
            <div class="field_line">
              <div class="name">
                <p class="field_title">7- Nome</p>
                <div>
                  <p class="response"> {{ this.formData[6].value }} </p>
                </div>
              </div>
              <div class="number_sus">
                <p class="field_title">8- Número do Cartão Nacional de Saúde</p>
                <div>
                  <p class="response"> {{ this.formData[7].value }} </p>
                </div>
              </div>
            </div>

            <h6 class="subtitle">Dados do Contratado</h6>

            <div class="field_line">
              <div class="cpf_number">
                <p class="field_title">9- Código na Operadora / CNPJ/ CPF</p>
                <div>
                  <p class="response"> {{ this.formData[8].value }} </p>
                </div>
              </div>

              <div class="name_cnes">
                <p class="field_title">10- Nome do Contratado</p>
                <div>
                  <p class="response"> {{ this.formData[9].value }} </p>
                </div>
              </div>

              <div class="code_cnes">
                <p class="field_title">11- Código CNES</p>
                <div>
                  <p class="response"> {{ this.formData[10].value }} </p>
                </div>
              </div>
            </div>

            <div class="field_line">
              <div class="tl_number">
                <p class="field_title">12- T.L</p>
                <div>
                  <p class="response"></p>
                </div>
              </div>

              <div class="name_cnes">
                <p class="field_title">13-14-15 Logradouro - Número - Complemento</p>
                <div>
                  <p class="response"> </p>
                </div>
              </div>

              <div class="code_cnes">
                <p class="field_title">16- Município</p>
                <div>
                  <p class="response"> </p>
                </div>
              </div>

              <div class="uf_cnes">
                <p class="field_title">17- UF</p>
                <div>
                  <p class="response"> </p>
                </div>
              </div>

              <div class="ibge_cnes">
                <p class="field_title">18- Código IBGE</p>
                <div>
                  <p class="response"> </p>
                </div>
              </div>

              <div class="code_cnes">
                <p class="field_title">19- CEP</p>
                <div>
                  <p class="response"> </p>
                </div>
              </div>
            </div>

            <div class="field_line">
              <div class="professional_cnes">
                <p class="field_title">20- Nome do Profissional executante</p>
                <div>
                  <p class="response"> {{ this.formData[11].value }} </p>
                </div>
              </div>
              <div class="conselho_cnes">
                <p class="field_title">21- Conselho Profissional</p>
                <div>
                  <p class="response">{{ this.formData[12].value }}</p>
                </div>
              </div>
              <div class="number_cnes">
                <p class="field_title">22- Número do Conselho</p>
                <div>
                  <p class="response">{{ this.formData[13].value }}</p>
                </div>
              </div>
              <div class="uf_cnes">
                <p class="field_title">23- UF</p>
                <div>
                  <p class="response"> {{ this.formData[14].value }} </p>
                </div>
              </div>
              <div class="cbo_cnes">
                <p class="field_title">24- Código CBO S</p>
                <div>
                  <p class="response">{{ this.formData[15].value }}</p>
                </div>
              </div>
            </div>

            <h6 class="subtitle">Hipóteses Diagnósticas</h6>
            <div class="field_line">
              <div class="sick_type">
                <p class="field_title">25- tipo de doença</p>
                <div>
                  <p class="response"> </p>
                </div>
                <p class="field_subtitle">A- Aguda C- Crônica</p>
              </div>
              <div class="sick_type">
                <p class="field_title">26- tempo de doença</p>
                <div>
                  <p class="response"> </p>
                </div>
                <p class="field_subtitle">A- Anos M- Mês D- Dias</p>
              </div>
              <div class="professional_cnes">
                <p class="field_title">27- Indicação de Acidente</p>
                <div>
                  <p class="response">{{ this.formData[16].value }}</p>
                </div>
                <p class="field_subtitle">0- Acidente ou doença relacionada ao trabalho 1- Trânsito 2- Outros</p>
              </div>
            </div>
            <div class="field_line">
              <div class="cid">
                <p class="field_title">28- CID Principal</p>
                <div>
                  <p class="response"></p>
                </div>
              </div>
              <div class="cid">
                <p class="field_title">29- CID (2)</p>
                <div>
                  <p class="response"></p>
                </div>
              </div>
              <div class="cid">
                <p class="field_title">30- CID (3)</p>
                <div>
                  <p class="response"></p>
                </div>
              </div>
              <div class="cid">
                <p class="field_title">31- CID (4)</p>
                <div>
                  <p class="response"></p>
                </div>
              </div>
            </div>
            <h6 class="subtitle">Dados do Atendimento / Procedimento Realizado</h6>

            <div class="field_line">
              <div class="attendance_data">
                <p class="field_title">32- Data de Atendimento</p>
                <div>
                  <p class="response"></p>
                </div>
              </div>
              <div class="attendance_code">
                <p class="field_title">33- Código Tabela</p>
                <div>
                  <p class="response"></p>
                </div>
              </div>
              <div class="attendance_procedure">
                <p class="field_title">34- Código Procedimento</p>
                <div>
                  <p class="response"></p>
                </div>
              </div>
            </div>
            <div class="field_line">
              <div class="attendance_type">
                <p class="field_title">35- Tipo de consulta</p>
                <div>
                  <p class="response"></p>
                </div>
                <p class="field_subtitle_type">1- Primera 2- Seguimento 3- Pré-natal</p>
              </div>
              <div class="attendance_type">
                <p class="field_title">36- Tipo de Saída</p>

                <p class="response"></p>

                <p
                  class="field_subtitle_type"
                >1- Retorno 2- Retorno SADT 3- Referência 4- Internação 5- Alta</p>
              </div>
            </div>

            <div class="field_line">
              <div class="note">
                <p class="field_title">37- Observações</p>

                  <p class="response"></p>

              </div>
            </div>
            <div class="field_line">
              <div class="assignature">
                <p class="field_title">38- Data e Assinatura do Médico</p>
                <div>
                  <p class="response"></p>
                </div>
              </div>
              <div class="assignature">
                <p class="field_title">39- Data e Assinatura do Beneficiário ou Responsável</p>
                <div>
                  <p class="response"></p>
                </div>
               </div>
            </div>
         </div>
       </div>
    </div>
  </div>
</main>
</template>

<script>
export default {
  props: ['formData'],

  data () {
    return {
      loaded: false,
      localActive: false
    }
  },
  mounted () {
    this.loaded = false
    this.localActive = true
  },
  methods: {
    close () {
      this.loaded = false
      this.localActive = false
      this.$emit('cancel', true)
    },
    print () {
      this.$htmlToPaper('print', () => {
        this.$emit('cancel', true)
      })
    }
  }
}
</script>
